<template>
  <table id="GridViewRacing" class="accountTable" cellspacing="0" cellpadding="0" style="border-collapse:collapse;">
    <tr class="tableHead">
      <th scope="col" style="width:15%;">
        <div title="No."> {{ $t('no.') }}</div>
      </th>
      <th align="left" scope="col" style="width:14%;">
        <div title="Ngày">Ngày</div>
      </th>
      <th scope="col" style="width:26%;">
        <div title="Kết&nbsp;quả">Kết&nbsp;quả</div>
      </th>
      <th scope="col" style="width:10%;">
        <div title="Player/Banker">P/B</div>
      </th>
      <!-- <th scope="col" style="width:10%;">
        <div title="Tổng lá bài">Tổng lá bài</div>
      </th>
      <th scope="col" style="width:10%;">
        <div title="Tổng điẻm">Tổng điểm</div>
      </th> -->
    </tr>
    <BaccaratDetail
      v-for="(column, index) in content"
      :id="column.id"
      :key="index"
      :end-at="column.endAt"
      :data="getDataDetail(column)"
    />
    <tr>
      <td colspan="8">
        <div class="pagination">
          <a @click="$emit('first-Page')">«</a>
          <a @click="$emit('previous-Page')">‹</a>
          <input type="text" :value="page" readonly="readonly" />
          <a @click="$emit('next-Page')">›</a>
          <a @click="$emit('last-Page')">»</a>
        </div>
      </td>
    </tr>
  </table>
</template>

<script>
import BaccaratDetail from '@components/content/result/baccarat-detail.vue';
import { calculateScore } from '@handlers/baccarat/result.js';

export default {
  components: {
    BaccaratDetail
  },
  props: {
    page: String,
    content: Array,
  },
  methods: {
    getDataDetail: function(column){
      if(column.resultRaw === undefined){
        return {};
      }
      return calculateScore(column);
    },
  }
}
</script>
